/**
 * Country names for an origin's country field, in the portal's language.
 *
 * The API's country register (GET /countries) replaces this once the portal
 * talks to it; until then the browser's own region names serve, which also
 * gives each language its own spelling for free.
 */

/** Region codes Intl names that are not countries an origin can be in. */
const NOT_COUNTRIES = new Set(['EU', 'EZ', 'UN', 'QO', 'ZZ', 'AC', 'CP', 'DG', 'EA', 'IC', 'TA', 'XA', 'XB'])

const cache = new Map<string, { code: string; name: string }[]>()

export function countries(language: string): { code: string; name: string }[] {
  const hit = cache.get(language)
  if (hit) return hit
  let names: Intl.DisplayNames
  try {
    names = new Intl.DisplayNames([language, 'en'], { type: 'region' })
  } catch {
    return []
  }
  const out: { code: string; name: string }[] = []
  const A = 'A'.charCodeAt(0)
  for (let i = 0; i < 26; i++) {
    for (let j = 0; j < 26; j++) {
      const code = String.fromCharCode(A + i, A + j)
      if (NOT_COUNTRIES.has(code)) continue
      const name = names.of(code)
      if (name && name !== code) out.push({ code, name })
    }
  }
  out.sort((a, b) => a.name.localeCompare(b.name, language))
  cache.set(language, out)
  return out
}

export function countryName(code: string, language: string): string {
  try {
    return new Intl.DisplayNames([language, 'en'], { type: 'region' }).of(code) ?? code
  } catch {
    return code
  }
}
